import React from "react";
import classNames from "classnames";
import { UserPictureCache } from "Hooks";
import { ActivityProperties } from "./types";
import { AvatarCircleWithCache } from "Components/AvatarCircle";

import classes from "./ClusterMarker.module.scss";

interface ClusterMarkerProps {
   count: number;
   activities: ActivityProperties[];
   pictureCache: UserPictureCache;
}

const SIZE = "sm";

const formatCountLabel = (count: number) => {
   if (count < 1000) {
      return count;
   }
   if (count > 99999) {
      return "99k";
   }
   const t = Math.floor(count / 1000);
   return `${t}k`;
};

const ClusterMarker: React.FC<ClusterMarkerProps> = ({ count, activities, pictureCache }) => {
   const additionalActivities = count - activities.length;
   return (
      <div className={classes.clusterContainer}>
         {activities.map(({ memberFullName, memberEmail, memberId }, i) => {
            const [firstName, lastName] = (memberFullName ?? "").split(" ");

            return (
               <AvatarCircleWithCache
                  key={`${memberEmail}_${i}`}
                  cache={pictureCache}
                  userId={memberId}
                  firstName={firstName}
                  lastName={lastName}
                  email={memberEmail ?? "Unknown"}
                  size={SIZE}
               />
            );
         })}
         {additionalActivities > 0 && (
            <div
               className={classNames(
                  "avatar-circle",
                  `avatar-circle-${SIZE}`,
                  classes.countCircle
               )}
            >
               +{formatCountLabel(additionalActivities)}
            </div>
         )}
      </div>
   );
};

export default ClusterMarker;
